const simplest = {
    'states': [
        {
            'id': '612c89b5-28c4-4c7c-af01-9d3cff52a50b',
            'label': 'Nový',
            'color': null,
        },
        {
            'id': 'ef052e2b-6497-4481-8695-82df81826daf',
            'label': 'Řeší se',
            'color': null,
        },
        {
            'id': '80b6948f-ceb6-48eb-9ae8-d359b5b22282',
            'label': 'Hotovo',
            'color': null,
        },
    ],
    'connections': [
        {
            'id': 'f85957ff-5ee1-4e96-b838-d18f766fef1e',
            'label': 'Začít',
            'from': '612c89b5-28c4-4c7c-af01-9d3cff52a50b',
            'to': 'ef052e2b-6497-4481-8695-82df81826daf',
            'guards': [
                'must_have_assignee',
            ],
            'event': 'manually',
        },
        {
            'id': 'b77af7bc-ae23-443e-8113-78a3c5c0ce3e',
            'label': 'Dokončit',
            'from': 'ef052e2b-6497-4481-8695-82df81826daf',
            'to': '80b6948f-ceb6-48eb-9ae8-d359b5b22282',
            'guards': [
                'must_comment_event',
            ],
            'event': 'manually',
        },
    ],
    'defaultState': '612c89b5-28c4-4c7c-af01-9d3cff52a50b',
    'endStates': [
        '80b6948f-ceb6-48eb-9ae8-d359b5b22282',
    ],
}

const simple = {
    'states': [
        {
            'id': '612c89b5-28c4-4c7c-af01-9d3cff52a50b',
            'label': 'Nový',
            'color': null,
        },
        {
            'id': 'ef052e2b-6497-4481-8695-82df81826daf',
            'label': 'Řeší se',
            'color': '#0000FF',
        },
        {
            'id': '424d6b97-aa92-4775-b25d-95598cb6be20',
            'label': 'K řešení',
            'color': '#00FF00',
        },
        {
            'id': 'cec3b3fb-5c04-4eb9-909f-551d133c0080',
            'label': 'K opravě',
            'color': '#FF0000',
        },
        {
            'id': 'd6a87381-76f7-436e-886e-acdb4b579783',
            'label': 'Dokončeno',
            'color': null,
        },
        {
            'id': 'c3329d00-24fb-4bcc-8676-c07459143353',
            'label': 'Hotovo',
            'color': null,
        },
        {
            'id': 'f274df3d-005a-4939-b4e4-71660d7eb38a',
            'label': 'Zamítnuto',
            'color': '#FF00FF',
        },
    ],
    'connections': [
        {
            'id': 'f85957ff-5ee1-4e96-b838-d18f766fef1e',
            'label': 'Přiřadit',
            'from': '612c89b5-28c4-4c7c-af01-9d3cff52a50b',
            'to': '424d6b97-aa92-4775-b25d-95598cb6be20',
            'guards': [
                'must_have_assignee',
            ],
            'event': 'automatic',
        },
        {
            'id': 'b77af7bc-ae23-443e-8113-78a3c5c0ce3e',
            'label': 'Dokončit',
            'from': 'ef052e2b-6497-4481-8695-82df81826daf',
            'to': 'c3329d00-24fb-4bcc-8676-c07459143353',
            'guards': [
                'must_comment_event',
            ],
            'event': 'manually',
        },
        {
            'id': '7e61f166-a8b5-45d1-b72e-db393f37cdc8',
            'label': 'Začít řešit',
            'from': '424d6b97-aa92-4775-b25d-95598cb6be20',
            'to': 'ef052e2b-6497-4481-8695-82df81826daf',
            'guards': [],
            'event': 'manually',
        },
        {
            'id': '3f20d510-453d-452b-87c9-a0ba3b7cedd0',
            'label': 'Opravit',
            'from': 'c3329d00-24fb-4bcc-8676-c07459143353',
            'to': 'cec3b3fb-5c04-4eb9-909f-551d133c0080',
            'guards': [
                'must_comment_event',
            ],
            'event': 'manually',
        },
        {
            'id': '1d15ae67-566f-443a-83d3-c6c52b652d19',
            'label': 'Začít opravovat',
            'from': 'cec3b3fb-5c04-4eb9-909f-551d133c0080',
            'to': 'ef052e2b-6497-4481-8695-82df81826daf',
            'guards': [],
            'event': 'manually',
        },
        {
            'id': '55e08799-87b5-4ca9-a963-62b99ef1721e',
            'label': 'Odsouhlasit',
            'from': 'c3329d00-24fb-4bcc-8676-c07459143353',
            'to': 'd6a87381-76f7-436e-886e-acdb4b579783',
            'guards': [],
            'event': 'manually',
        },
        {
            'id': '612de320-d215-428d-89c4-9621fa2c5be4',
            'label': 'Zamítnout',
            'from': '612c89b5-28c4-4c7c-af01-9d3cff52a50b',
            'to': 'f274df3d-005a-4939-b4e4-71660d7eb38a',
            'guards': [
                'only_author',
                'must_comment_event',
            ],
            'event': 'manually',
        },
        {
            'id': '243f14fc-83ad-4372-a1fe-7270331edba8',
            'label': 'Zamítnout',
            'from': '424d6b97-aa92-4775-b25d-95598cb6be20',
            'to': 'f274df3d-005a-4939-b4e4-71660d7eb38a',
            'guards': [
                'only_author',
                'must_comment_event',
            ],
            'event': 'manually',
        },
    ],
    'defaultState': '612c89b5-28c4-4c7c-af01-9d3cff52a50b',
    'endStates': [
        'd6a87381-76f7-436e-886e-acdb4b579783',
        'f274df3d-005a-4939-b4e4-71660d7eb38a',
    ],
}

export default {
    simplest: {
        label: 'Nejjednodušší',
        data: simplest,
    },
    simple: {
        label: 'Jednoduchý',
        data: simple,
    },
}
